import * as React from 'react'

import { Tag } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { DUE_STATES, DueDateState } from 'modules/notifications/lib/DueDateState'

type DueStateBadgeProps = {
  state?: DueDateState | null
  days?: number
}

export const DueStateBadge = observer(({ state, days }: DueStateBadgeProps) => {
  switch (state) {
    case DUE_STATES.overdue:
      return (
        <Tag type="radical" inline>
          {i18n.t('dashboard.todo.due_date.overdue')}
        </Tag>
      )
    case DUE_STATES.dueToday:
      return (
        <Tag type="champagne" inline>
          {i18n.t('dashboard.todo.due_date.today')}
        </Tag>
      )
    case DUE_STATES.dueTomorrow:
      return (
        <Tag type="grey" inline>
          {i18n.t('dashboard.todo.due_date.tomorrow')}
        </Tag>
      )
    case DUE_STATES.dueSoon:
      if (days) {
        return (
          <Tag type="grey" inline>
            {i18n.t('dashboard.todo.due_date.dueSoon', { n: days })}
          </Tag>
        )
      }
  }

  return null
})
